export const minutesToHHMM = (minutes) => {
  if (!minutes && minutes !== 0) return '--:--';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

export const hhmmToMinutes = (hhmm) => {
  if (!hhmm) return 0;
  const [h, m] = hhmm.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const formatDuration = (minutes) => {
  if (!minutes && minutes !== 0) return '0h';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};

export const resolveRate = ({ entry, task, member, project }) => {
  if (entry?.hourlyRate != null) return entry.hourlyRate;
  if (task?.hourlyRate != null) return task.hourlyRate;
  if (member?.hourlyRate != null) return member.hourlyRate;
  if (project?.hourlyRate != null) return project.hourlyRate;
  return 0;
};

export const resolveBillable = ({ entry, task, project }) => {
  if (entry?.billable != null) return entry.billable;
  if (task?.billable != null) return task.billable;
  return project?.billable || false;
};

export const calculateDailyTotal = (entries) => {
  return entries.reduce((sum, e) => sum + (e.duration || 0), 0);
};

export const calculateBillablePercentage = (entries) => {
  const total = entries.length;
  if (total === 0) return 0;
  const billable = entries.filter((e) => e.billable).length;
  return Math.round((billable / total) * 100);
};
